import { useState } from "react";
import { faqList } from "@/mocks/guaMore";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-white">
      <div className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-[0.2em] text-red-700">常见问题</p>
          <h2 className="font-masthead mt-2 text-2xl font-black text-stone-900 md:text-3xl">
            关于「全网热瓜」，你可能想了解
          </h2>
        </div>

        <div className="mt-8 divide-y divide-orange-900/10 rounded-xl border border-orange-900/10 bg-[#faf6ee]">
          {faqList.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q}>
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span className="font-masthead text-lg font-black text-red-700">Q</span>
                    <h3 className="text-sm font-semibold text-stone-800 md:text-base">{f.q}</h3>
                  </span>
                  <i
                    className={`shrink-0 text-stone-400 transition-transform ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <div className="flex gap-3 rounded-lg bg-white p-4">
                      <span className="font-masthead text-lg font-black text-amber-600">A</span>
                      <p className="text-sm leading-relaxed text-stone-600">{f.a}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}